import script from "./tickets.vue?vue&type=script&setup=true&lang=js"
export * from "./tickets.vue?vue&type=script&setup=true&lang=js"

import "./tickets.vue?vue&type=style&index=0&id=057df576&lang=scss"

const __exports__ = script;

export default __exports__